import { ReactNode } from "react";
import InfoIcon from "@mui/icons-material/Info";
import { IconButton, Stack, Tooltip, Typography, type TooltipProps } from "@financeable-com-au/financeable-ui";

interface InfoTooltipProps {
  /** Tooltip content. Plain strings are wrapped in the standard padded body-sm layout; nodes are rendered as-is. */
  title: ReactNode;
  placement?: TooltipProps["placement"];
  iconColor?: string;
  iconFontSize?: string | number;
}

const InfoTooltip = ({ title, placement, iconColor, iconFontSize = "1rem" }: InfoTooltipProps) => (
  <Tooltip
    placement={placement}
    title={
      typeof title === "string" ? (
        <Stack padding={2}>
          <Typography level="body-sm">{title}</Typography>
        </Stack>
      ) : (
        title
      )
    }
  >
    <IconButton aria-label="Tooltip" isRounded={true} size="sm" variant="inline">
      <InfoIcon sx={{ fontSize: iconFontSize, ...(iconColor ? { color: iconColor } : {}) }} />
    </IconButton>
  </Tooltip>
);

export default InfoTooltip;
